import zhCn from 'element-plus/es/locale/lang/zh-cn';
export default {
  data: function data() {
    return {
      locale: zhCn
    };
  }
};